import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';

import { DashboardContainerComponent } from './dashboard/dashboard-container/dashboard-container.component';
import { ErrorHandlerService } from './shared/services/error-handler.service';
import { GlobalErrorHandler } from './shared/error/global-error-handler';
import { GlobalErrorComponent } from './global-error/global-error.component';
import { RolesAuthGuardService } from './shared/services/roles-auth-guard.service';
import { Error500Component } from './error/error-500/error-500.component';
import { ErrorNavigationService } from './mega-exchange/services/error-navigation.service';
import { CanDeactivateGuardService } from './rcr-exchange/services/can-deactivate-guard.service';

const appRoutes: Routes = [
  {
    path: '',
    component: DashboardContainerComponent,
    pathMatch: 'full',
  },
  {
    path: 'rcr-exchange',
    canLoad: [RolesAuthGuardService],
    // loadChildren: 'app/rcr-exchange/rcr-exchange.module#RCRExchangeModule'
    loadChildren: () =>
      import('app/rcr-exchange/rcr-exchange.module').then((m) => m.RCRExchangeModule),
  },
  {
    path: 'mega-trade',
    canLoad: [RolesAuthGuardService],
    // loadChildren: 'app/mega-exchange/mega-trade.module#MegaTradeModule'
    loadChildren: () =>
      import('app/mega-exchange/mega-trade.module').then((m) => m.MegaTradeModule),
  },
  {
    path: 'remic-shelf',
    canLoad: [RolesAuthGuardService],
    loadChildren: () =>
      import('app/remic-shelf/remic-shelf.module').then((m) => m.RemicShelfModule),
  },
  {
    path: '404',
    component: GlobalErrorComponent,
  },
  {
    path: 'error',
    component: Error500Component,
    canDeactivate: [CanDeactivateGuardService],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, {
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'always',
      initialNavigation: 'enabledBlocking',
      canceledNavigationResolution: 'computed',
    }),
  ],
  declarations: [],
  providers: [
    ErrorHandlerService,
    ErrorNavigationService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
})
export class AppRoutingModule {}
